(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_ko-tab-faq"] && !Shopify.designMode) return;
  try {
    // Temaeditor: vælges et FAQ-punkt eller et af dets punkter, åbnes det
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest && e.target.closest('.ko-tfaq');
    if (d) d.open = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_ko-tab-review"] && !Shopify.designMode) return;
  try {
    (function () {
    // Bygger en filterbjælke i hver fane, hvor anmeldelserne har tags
    function build(scope) {
      (scope || document).querySelectorAll('.ko-tabs__panel').forEach(function (panel) {
        var old = panel.querySelector(':scope > .ko-rtags');
        if (old) old.remove();
        var revs = Array.prototype.slice.call(panel.querySelectorAll('.ko-tabrev'));
        var tags = [];
        var count = {};
        revs.forEach(function (r) {
          (r.dataset.revTags || '').split('|').forEach(function (t) {
            t = t.trim();
            if (!t) return;
            var k = t.toLowerCase();
            if (!(k in count)) { count[k] = 0; tags.push(t); }
            count[k]++;
          });
        });
        revs.forEach(function (r) { r.classList.remove('is-hidden'); });
        if (!tags.length) { mark(revs); return; }
        var bar = document.createElement('div');
        bar.className = 'ko-rtags';
        bar.setAttribute('role', 'toolbar');
        var mk = function (label, key, n) {
          var b = document.createElement('button');
          b.type = 'button';
          b.dataset.key = key;
          b.textContent = label;
          var s = document.createElement('small');
          s.textContent = n;
          b.appendChild(s);
          bar.appendChild(b);
        };
        mk(panel.dataset.filterAll || 'Alle', '', revs.length);
        tags.forEach(function (t) { mk(t, t.toLowerCase(), count[t.toLowerCase()]); });
        var first = revs[0].closest('.shopify-block') || revs[0];
        first.parentNode.insertBefore(bar, first);
        var apply = function (key) {
          bar.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b.dataset.key === key); });
          revs.forEach(function (r) {
            var keys = (r.dataset.revTags || '').toLowerCase().split('|').map(function (x) { return x.trim(); });
            r.classList.toggle('is-hidden', !!key && keys.indexOf(key) < 0);
          });
          mark(revs);
        };
        bar.addEventListener('click', function (e) {
          var b = e.target.closest('button');
          if (b) apply(b.dataset.key);
        });
        panel.addEventListener('click', function (e) {
          var t = e.target.closest && e.target.closest('[data-rev-tag]');
          if (!t || !panel.contains(t)) return;
          apply(t.dataset.revTag.toLowerCase());
          bar.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        });
        panel._koRevApply = apply;
        apply('');
      });
    }
    // Første synlige anmeldelse har ingen skillelinje
    function mark(revs) {
      var seen = false;
      revs.forEach(function (r) {
        var vis = !r.classList.contains('is-hidden');
        r.classList.toggle('is-first', vis && !seen);
        if (vis) seen = true;
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { build(); });
    else build();
    document.addEventListener('shopify:section:load', function (e) { build(e.target); });
    // Temaeditor: vælges en skjult anmeldelse, nulstilles filteret
    document.addEventListener('shopify:block:select', function (e) {
      var r = e.target.querySelector ? (e.target.matches('.ko-tabrev') ? e.target : e.target.querySelector('.ko-tabrev')) : null;
      var panel = r && r.closest('.ko-tabs__panel');
      if (panel && panel._koRevApply && r.classList.contains('is-hidden')) panel._koRevApply('');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
